import type { LargeCategoryCode } from './-query/type';

export const LARGE_CATEGORY_CODES = {
  PERSONAL_INFORMATION: 'PersonalInformation',
  EMPLOYEE_INFORMATION: 'EmployeeInformation',
  CONTRACTOR_INFORMATION: 'ContractorInformation',
} as const satisfies Record<string, LargeCategoryCode>;
